import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';
import About from '../components/About';
import Guides from '../components/Guides';
import FAQ from '../components/FAQ';
import News from '../components/News';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Home = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Galo Bet - Comparateur de Sites de Paris en Ligne en France",
    "description": "Comparateur indépendant de sites de paris sportifs en ligne en France. Comparez les meilleures offres, bonus et sites agréés ANJ.",
    "url": "https://galo-bet.com",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Offres de Paris",
          "url": "https://galo-bet.com/#offres"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Guides de Paris",
          "url": "https://galo-bet.com/guides"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Actualités",
          "url": "https://galo-bet.com/news"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Avis Détaillés",
          "url": "https://galo-bet.com/reviews"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <SEO 
        title="Accueil"
        description="Galo Bet est votre comparateur indépendant pour les paris sportifs en ligne en France. Comparez les meilleures offres, bonus et sites agréés ANJ. Avis, guides et actualités pour parieurs français."
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <Hero />
        <Offers />
        <About />
        <Guides />
        <FAQ />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;

